export const EAT_CUISINES = [
  { id: 'burger', label: 'Burger', emoji: '🍔' },
  { id: 'fried_chicken', label: 'Poulet frit', emoji: '🍗' },
  { id: 'fast_food', label: 'Fast-food', emoji: '🍟' },
  { id: 'pizza', label: 'Pizza', emoji: '🍕' },
  { id: 'tacos', label: 'Tacos', emoji: '🌮' },
  { id: 'kebab', label: 'Kebab', emoji: '🥙' },
  { id: 'sandwich', label: 'Sandwich', emoji: '🥪' },
  { id: 'bowls', label: 'Bowls', emoji: '🥣' },
  { id: 'asian', label: 'Asiatique', emoji: '🍜' },
  { id: 'sushi', label: 'Sushi', emoji: '🍣' },
  { id: 'indian', label: 'Indien', emoji: '🍛' },
  { id: 'african', label: 'Africain', emoji: '🍲' },
  { id: 'french', label: 'Français', emoji: '🥖' },
  { id: 'italian', label: 'Italien', emoji: '🍝' },
  { id: 'grill', label: 'Grillades', emoji: '🥩' },
  { id: 'seafood', label: 'Poisson & fruits de mer', emoji: '🦐' },
  { id: 'healthy', label: 'Healthy', emoji: '🥗' },
  { id: 'bakery', label: 'Boulangerie', emoji: '🥐' },
  { id: 'dessert', label: 'Dessert', emoji: '🍰' },
  { id: 'ice_cream', label: 'Glaces', emoji: '🍦' },
  { id: 'coffee', label: 'Cafe', emoji: '☕' }
];

export const MENU_CATEGORY_PRESETS = [
  { id: 'entrees', name: 'Entrées', cuisineId: 'french', color: '#0f766e', backgroundColor: '#ecfdf5' },
  { id: 'plats', name: 'Plats', cuisineId: 'french', color: '#b45309', backgroundColor: '#fff7ed' },
  { id: 'desserts', name: 'Desserts', cuisineId: 'dessert', color: '#be185d', backgroundColor: '#fdf2f8' },
  { id: 'sides', name: 'Sides', cuisineId: 'fast_food', color: '#7c3aed', backgroundColor: '#f5f3ff' },
  { id: 'boissons', name: 'Boissons', cuisineId: 'coffee', color: '#2563eb', backgroundColor: '#eff6ff' },
  { id: 'autres', name: 'Autres', cuisineId: 'fast_food', color: '#475569', backgroundColor: '#f8fafc' }
];

const LEGACY_MENU_CATEGORY_LABELS = {
  entree: 'Entrées',
  starters: 'Entrées',
  mains: 'Plats',
  menus: 'Plats',
  burgers: 'Plats',
  buckets: 'Plats',
  tacos: 'Plats',
  bowls: 'Plats',
  kids: 'Plats',
  'fried-chicken': 'Plats',
  'wings-tenders': 'Plats',
  dessert: 'Desserts',
  side: 'Sides',
  snacks: 'Sides',
  accompagnements: 'Sides',
  drinks: 'Boissons',
  coffee: 'Boissons',
  other: 'Autres'
};

const LEGACY_MENU_SECTION_IDS = {
  entree: 'entrees',
  entrees: 'entrees',
  starters: 'entrees',
  plats: 'plats',
  mains: 'plats',
  menus: 'plats',
  burgers: 'plats',
  buckets: 'plats',
  tacos: 'plats',
  bowls: 'plats',
  kids: 'plats',
  'fried-chicken': 'plats',
  'wings-tenders': 'plats',
  desserts: 'desserts',
  dessert: 'desserts',
  sides: 'sides',
  side: 'sides',
  snacks: 'sides',
  accompagnements: 'sides',
  boissons: 'boissons',
  drinks: 'boissons',
  coffee: 'boissons',
  autres: 'autres',
  other: 'autres'
};

const normalizeText = (value = '') => String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();

export const BRAND_ACCENTS = [
  { id: 'allo-gold', label: 'Or Allô', color: '#C9A227' },
  { id: 'deep-black', label: 'Noir', color: '#070707' },
  { id: 'warm-white', label: 'Blanc chaud', color: '#F7F2E7' },
  { id: 'graphite', label: 'Graphite', color: '#252525' }
];

export const DEFAULT_EAT_HEADERS = [
  {
    id: 'burger-house',
    label: 'Burger photo',
    cuisineId: 'burger',
    imageUrl: 'https://images.unsplash.com/photo-1568901346375-23c9450c58cd?auto=format&fit=crop&w=1200&q=80'
  },
  {
    id: 'pizza-oven',
    label: 'Pizza photo',
    cuisineId: 'pizza',
    imageUrl: 'https://images.unsplash.com/photo-1513104890138-7c749659a591?auto=format&fit=crop&w=1200&q=80'
  },
  {
    id: 'asian-bowl',
    label: 'Asiatique photo',
    cuisineId: 'asian',
    imageUrl: 'https://images.unsplash.com/photo-1569718212165-3a8278d5f624?auto=format&fit=crop&w=1200&q=80'
  },
  {
    id: 'fresh-salad',
    label: 'Healthy photo',
    cuisineId: 'healthy',
    imageUrl: 'https://images.unsplash.com/photo-1546069901-ba9599a7e63c?auto=format&fit=crop&w=1200&q=80'
  }
];

export const EAT_COURIER_MODES = [
  { id: 'bike', label: 'Velo' },
  { id: 'scooter', label: 'Scooter' },
  { id: 'motorbike', label: 'Moto' },
  { id: 'car', label: 'Voiture' },
  { id: 'walker', label: 'A pied' }
];

export const cuisineLookup = EAT_CUISINES.reduce((lookup, cuisine) => {
  lookup[cuisine.id] = cuisine.label;
  return lookup;
}, {});

export const courierModeLookup = EAT_COURIER_MODES.reduce((lookup, mode) => {
  lookup[mode.id] = mode.label;
  return lookup;
}, {});

export const cuisineLabel = (value) => {
  const cuisine = EAT_CUISINES.find(item => item.id === value || item.label === value);
  return cuisine ? `${cuisine.emoji} ${cuisine.label}` : (value || 'Cuisine');
};

export const categoryLabel = (value) => {
  const category = MENU_CATEGORY_PRESETS.find(item => item.id === value || item.name === value);
  return category ? category.name : (LEGACY_MENU_CATEGORY_LABELS[value] || value || 'Categorie');
};

export const menuSectionId = (item = {}, categoryLookup = {}) => {
  const category = categoryLookup[item.categoryId] || {};
  const categoryId = normalizeText(item.categoryId);
  const itemText = normalizeText(`${item.name || ''} ${item.description || ''}`);
  const categoryText = normalizeText(`${item.categoryName || ''} ${category.name || ''}`);

  if (LEGACY_MENU_SECTION_IDS[categoryId]) return LEGACY_MENU_SECTION_IDS[categoryId];
  if (/\b(tiramisu|muffin|dessert|gateau|glace|sucre|cookie|brownie)\b/.test(itemText)) return 'desserts';
  if (/\b(chips|frites|frite|side|snack|accompagnement|nuggets|mozza|onion)\b/.test(itemText)) return 'sides';
  if (/\b(coca|cola|fanta|orangina|tropico|7up|boisson|canette|eau|jus|soda|milk|cafe)\b/.test(itemText)) return 'boissons';
  if (/entree|starter/.test(categoryText)) return 'entrees';
  if (/dessert|glace/.test(categoryText)) return 'desserts';
  if (/side|snack|accompagnement|frite/.test(categoryText)) return 'sides';
  if (/boisson|drink|cafe/.test(categoryText)) return 'boissons';
  if (/plat|menu|burger|bucket|taco|bowl|kids|poulet/.test(categoryText)) return 'plats';
  return 'autres';
};